/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
export var CreateDdfwTeamAndTeamAccountStatus;
(function (CreateDdfwTeamAndTeamAccountStatus) {
    CreateDdfwTeamAndTeamAccountStatus["ONBOARD_TEAM_ACCOUNT_STATUS_ERROR"] = "ONBOARD_TEAM_ACCOUNT_STATUS_ERROR";
    CreateDdfwTeamAndTeamAccountStatus["ONBOARD_TEAM_ACCOUNT_STATUS_IN_PROGRESS"] = "ONBOARD_TEAM_ACCOUNT_STATUS_IN_PROGRESS";
    CreateDdfwTeamAndTeamAccountStatus["ONBOARD_TEAM_ACCOUNT_STATUS_SUCCESS"] = "ONBOARD_TEAM_ACCOUNT_STATUS_SUCCESS";
    CreateDdfwTeamAndTeamAccountStatus["ONBOARD_TEAM_ACCOUNT_STATUS_UNSPECIFIED"] = "ONBOARD_TEAM_ACCOUNT_STATUS_UNSPECIFIED";
})(CreateDdfwTeamAndTeamAccountStatus || (CreateDdfwTeamAndTeamAccountStatus = {}));
export var LimitationType;
(function (LimitationType) {
    LimitationType["MAX_ADD_CARD_PAYMENT_ATTEMPTS_MONTHLY"] = "MAX_ADD_CARD_PAYMENT_ATTEMPTS_MONTHLY";
    LimitationType["MAX_BUDGETS_PER_TEAM_ACCOUNT"] = "MAX_BUDGETS_PER_TEAM_ACCOUNT";
    LimitationType["MAX_BUDGET_AMOUNT"] = "MAX_BUDGET_AMOUNT";
    LimitationType["MAX_MEMBERS_PER_TEAM_ACCOUNT"] = "MAX_MEMBERS_PER_TEAM_ACCOUNT";
    LimitationType["UNKNOWN_LIMITATION_TYPE"] = "UNKNOWN_LIMITATION_TYPE";
})(LimitationType || (LimitationType = {}));
/**
 * new team account onboarding steps
 */
export var OnboardingStep;
(function (OnboardingStep) {
    OnboardingStep["ONBOARDING_STEP_ACTIVATE_DASHPASS"] = "ONBOARDING_STEP_ACTIVATE_DASHPASS";
    OnboardingStep["ONBOARDING_STEP_ADD_BUDGET"] = "ONBOARDING_STEP_ADD_BUDGET";
    OnboardingStep["ONBOARDING_STEP_ADD_MEMBER"] = "ONBOARDING_STEP_ADD_MEMBER";
    OnboardingStep["ONBOARDING_STEP_ADD_PAYMENT_METHOD"] = "ONBOARDING_STEP_ADD_PAYMENT_METHOD";
    OnboardingStep["ONBOARDING_STEP_FINISH_ONBOARDING"] = "ONBOARDING_STEP_FINISH_ONBOARDING";
    OnboardingStep["ONBOARDING_STEP_UNKNOWN"] = "ONBOARDING_STEP_UNKNOWN";
})(OnboardingStep || (OnboardingStep = {}));
export var PaymentMethodConfigCountry;
(function (PaymentMethodConfigCountry) {
    PaymentMethodConfigCountry["AU"] = "AU";
    PaymentMethodConfigCountry["CA"] = "CA";
    PaymentMethodConfigCountry["DE"] = "DE";
    PaymentMethodConfigCountry["JP"] = "JP";
    PaymentMethodConfigCountry["MX"] = "MX";
    PaymentMethodConfigCountry["NZ"] = "NZ";
    PaymentMethodConfigCountry["PR"] = "PR";
    PaymentMethodConfigCountry["US"] = "US";
})(PaymentMethodConfigCountry || (PaymentMethodConfigCountry = {}));
export var PaymentMethodConfigProvider;
(function (PaymentMethodConfigProvider) {
    PaymentMethodConfigProvider["braintree"] = "braintree";
    PaymentMethodConfigProvider["jpm"] = "jpm";
    PaymentMethodConfigProvider["stripe"] = "stripe";
    PaymentMethodConfigProvider["vgs"] = "vgs";
})(PaymentMethodConfigProvider || (PaymentMethodConfigProvider = {}));
export var TeamAccountPlan;
(function (TeamAccountPlan) {
    TeamAccountPlan["WORK_PLAN_MANUAL_MANAGEMENT_FREE"] = "WORK_PLAN_MANUAL_MANAGEMENT_FREE";
    TeamAccountPlan["WORK_PLAN_SELF_SERVE_FREE"] = "WORK_PLAN_SELF_SERVE_FREE";
})(TeamAccountPlan || (TeamAccountPlan = {}));
/**
 * Team member role types
 */
export var TeamMemberRole;
(function (TeamMemberRole) {
    TeamMemberRole["ADMIN"] = "ADMIN";
    TeamMemberRole["MEMBER"] = "MEMBER";
})(TeamMemberRole || (TeamMemberRole = {}));
/**
 * types of work benefit offered on team account
 */
export var WorkBenefit;
(function (WorkBenefit) {
    WorkBenefit["WORK_BENEFIT_DASHPASS"] = "WORK_BENEFIT_DASHPASS";
    WorkBenefit["WORK_BENEFIT_EXPENSED_MEALS"] = "WORK_BENEFIT_EXPENSED_MEALS";
    WorkBenefit["WORK_BENEFIT_UNSPECIFIED"] = "WORK_BENEFIT_UNSPECIFIED";
})(WorkBenefit || (WorkBenefit = {}));
/**
 * workflow name is used for retrieving the selected workflow status
 */
export var WorkflowName;
(function (WorkflowName) {
    WorkflowName["WORKFLOW_NAME_ACTIVATE_BENEFIT"] = "WORKFLOW_NAME_ACTIVATE_BENEFIT";
    WorkflowName["WORKFLOW_NAME_ONBOARD_TEAM_ACCOUNT"] = "WORKFLOW_NAME_ONBOARD_TEAM_ACCOUNT";
    WorkflowName["WORKFLOW_NAME_REMOVE_BENEFIT"] = "WORKFLOW_NAME_REMOVE_BENEFIT";
})(WorkflowName || (WorkflowName = {}));
export var WorkflowStatus;
(function (WorkflowStatus) {
    WorkflowStatus["WORKFLOW_STATUS_ERROR"] = "WORKFLOW_STATUS_ERROR";
    WorkflowStatus["WORKFLOW_STATUS_IN_PROGRESS"] = "WORKFLOW_STATUS_IN_PROGRESS";
    WorkflowStatus["WORKFLOW_STATUS_SUCCESS"] = "WORKFLOW_STATUS_SUCCESS";
    WorkflowStatus["WORKFLOW_STATUS_UNSPECIFIED"] = "WORKFLOW_STATUS_UNSPECIFIED";
})(WorkflowStatus || (WorkflowStatus = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
